import { IonButtons, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';
import { Filesystem, Directory, GetUriOptions, Encoding } from '@capacitor/filesystem';

import NServer from "../components/NServer";
import Vault from '../components/Vault';

import '../pages/Main.css'; 

export interface GifData {
    categories : string[];
    gifs : string[];
    cached_gifs : string[];
}

interface GifProp {
    content : GifData,
    onSend : any,
    onHide : any,
    onChange : any
}


// download and save a Gif
const DownloadAndSaveGif = async (gif : string) : Promise<string> => {
    //  no cache yet
    return gif;
}

// load the gift list
export const LoadGifs = async (cat : number) : Promise<GifData> => {
    
    let v = new Vault();
    await v.read();

    const state = {
        id: v.account.id,
        pass: v.account.key,
        cat: cat
    }

    var server = new NServer();
    await server.getList("load_gif", state);
    if (server.success)
    {
        let gifData : GifData = { categories: [], gifs:[], cached_gifs:[] };
        let serverGifData : GifData = server.data;

        // copy categories
        for (let i = 0; i < serverGifData.categories.length; i++)
            gifData.categories.push(serverGifData.categories[i]);

        // load up the gif
        for (let i = 0; i < serverGifData.gifs.length; i++)
        {
            gifData.gifs.push(serverGifData.gifs[i]);
            
            // download gifs
            let cached = await DownloadAndSaveGif(serverGifData.gifs[i]);
            //DEL console.log("Cached gif-> " + cached);
            gifData.cached_gifs.push(cached);

            // gifData.cached_gifs.push(serverGifData.gifs[i]);

            // DownloadAndSaveGif(serverGifData.gifs[i]);

            // let cached_img = await cache.get({ src: serverGifData.gifs[i] });
            // console.log("Cached image-> " + cached_img.value);
            // gifData.cached_gifs.push(cached_img.value);
        }

        return gifData;
    }

    // error
    return { categories: [], gifs: [], cached_gifs:[] };
}

const GifContent : React.FC<GifProp> = ({ content, onSend, onHide, onChange }) => {
    
    const router = useIonRouter();

    return (
        <div className="gif-content">
            <IonToolbar>
                <IonItem className="gif-toolbar" slot="start" color="none" lines="none">
                    {
                        content.categories.map((m, index) =>
                    <IonChip key={index} onClick={ ()=> onChange(index) } className="no-flex">{ m }</IonChip>
                        )
                    }
                </IonItem>
                <IonButtons slot="end">
                    <IonButton onClick={onHide}>
                        <IonIcon icon={closeOutline} size="large"/>
                    </IonButton>
                </IonButtons>
            </IonToolbar>
            <div className="gif-body">
            {
                content.cached_gifs.map((m, index) =>
                    <IonImg key={index} className="gif" onClick={ ()=> onSend(content.gifs[index]) } src={m} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/gif_err.jpg' } } />
                )
            }
            </div>
        </div>
    );
};
  
export default GifContent;